module.exports = __webpack_public_path__ + "static/img/science4.0e9b8db1.png";